export enum LogLevel {
    info = 'info',
    warn = 'warn',
    error = 'error',
    success = 'success'
}

export const logLevelAsString = (logLevel: LogLevel, fullText = false): string => {
    switch (logLevel) {
        case LogLevel.info:
            return fullText ? "ℹ️ Information" : "ℹ️";
        case LogLevel.warn:
            return fullText ? "⚠️ Avertissement" : "⚠️";
        case LogLevel.error:
            return fullText ? "❌ Erreur" : "❌";
        case LogLevel.success:
            return fullText ? "✅ Succès" : "✅";
        default:
            return fullText ? "❓ Type inconnu" : "❓";
    }
};